import { GridColDef } from '@mui/x-data-grid-pro';
import { List, ListItem, ListItemText } from '@mui/material';
import { dataGridCol } from '@shared/components/grid/common';
import { formatString } from '@shared/commonFunctions';
import { statesList } from '@shared/constants/statesList';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { IOption } from '@shared/interfaces';
import { ILenderTabData, IStateTabData, IStipTypeData } from '../interfaces';

export const formatCellData = (rowData: IStipTypeData[]) => (
  <List>
    {rowData &&
      rowData.map((data, index) => (
        <ListItem key={index} component="div" disablePadding={true}>
          <ListItemText key={index} primary={formatString(data?.name)} />
        </ListItem>
      ))}
  </List>
);

export const stateTabFormConfig = (stipType: IOption[]) => [
  {
    width: '100%',
    name: 'stateCode',
    label: 'State',
    options: statesList,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'straightRefiBorrower',
    label: 'Straight Refi Borrower',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'straightRefiCoBorrower',
    label: 'Straight Refi Co-Borrower',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'add',
    label: 'Add',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'drop',
    label: 'Drop',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '100%',
    name: 'addDrop',
    label: 'Add/Drop',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'nameChangeBorrower',
    label: 'Name Change Borrower',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
  {
    width: '50%',
    name: 'nameChangeCoBorrower',
    label: 'Name Change Co-Borrower',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
];

export const stateTabColumns: GridColDef<IStateTabData>[] = [
  dataGridCol('stateCode', {
    headerName: 'State',
  }),
  dataGridCol('straightRefiBorrower', {
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row?.straightRefiBorrower) || '',
  }),
  dataGridCol('straightRefiCoBorrower', {
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.straightRefiCoBorrower) || '',
  }),
  dataGridCol('add', {
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.add) || '',
  }),
  dataGridCol('drop', {
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.drop) || '',
  }),
  dataGridCol('addDrop', {
    headerName: 'Add/Drop',
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.addDrop) || '',
  }),
  dataGridCol('nameChangeBorrower', {
    headerName: 'Name Change - Borrower',
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.nameChangeBorrower) || '',
  }),
  dataGridCol('nameChangeCoBorrower', {
    headerName: 'Name Change - CoBorrower',
    renderCell: ({ row }: { row: IStateTabData }) => formatCellData(row.nameChangeCoBorrower) || '',
  }),
].map((column) => ({ minWidth: 200, ...column }));

export const lenderTabFormConfig = (stipType: IOption[], lenderList: IOption[]) => [
  {
    width: '100%',
    name: 'lenderId',
    label: 'Lender',
    options: lenderList,
    component: SelectAutocompleteField,
  },
  {
    width: '100%',
    name: 'stipType',
    label: 'Stip Type',
    options: stipType,
    multiple: true,
    component: SelectAutocompleteField,
  },
];

export const lenderTabColumns: GridColDef<ILenderTabData>[] = [
  dataGridCol('lender', {
    minWidth: 250,
    headerName: 'Lender',
  }),
  dataGridCol('stipType', {
    minWidth: 600,
    headerName: 'Required Document',
    renderCell: ({ row }: { row: ILenderTabData }) => formatCellData(row.stipType) || '',
  }),
].map((column) => ({ flex: 1, ...column }));
